import React from 'react';
import { Button as AntButton } from 'antd';

/**
 * Componente de Button
 * @param {string} type - Tipo do botão (primary, default, dashed, link, text)
 * @param {string} size - Tamanho do botão (large, middle, small)
 * @param {boolean} loading - Se o botão está em loading
 * @param {boolean} disabled - Se o botão está desabilitado
 * @param {ReactNode} icon - Ícone do botão
 * @param {function} onClick - Função de clique
 * @param {ReactNode} children - Texto do botão
 */
const Button = ({ 
  type = 'default', 
  size = 'middle', 
  loading = false, 
  disabled = false, 
  icon = null, 
  onClick = () => {}, 
  children,
  ...props 
}) => {
  return (
    <AntButton
      type={type}
      size={size}
      loading={loading}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {children}
    </AntButton>
  );
};

export default Button;



